import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import { Icon } from "../../../components/core/Icon";
import { Select } from "../../../components/Select";
import { Loading } from "../../../components/Loading";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";

const TIPOS = [
    { title: "Texto", option: 'TEXT' },
    { title: "Opções", option: 'OPTIONS' }
];

const TIPOS_LABEL = {
    TEXT: "Texto",
    OPTIONS: "Opções"
}

function toAlias(titulo) {
    return (titulo || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_|_$/g, "");
}

const emptyForm = {
    titulo: "",
    alias: "",
    tipo: "TEXT",
    opcoes: [],
    novaOpcao: "",
};

export default class CustomerAttributesDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true,
            saveLoading: false,
            attributes: [],
            step: "list",
            editingIndex: null,
            form: { ...emptyForm },
        };
    }

    async componentDidMount() {
        const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();
        const attributes = await EnvironmentsAPI.getConfigurationsByAlias(
            environmentId,
            "customer_attributes",
            []
        );
        this.setState({ attributes: Array.isArray(attributes) ? attributes : [], pageLoading: false });
    }

    openAddForm() {
        this.setState({ step: "form", editingIndex: null, form: { ...emptyForm } });
    }

    openEditForm(index) {
        const { attributes } = this.state;
        const attr = attributes[index];
        this.setState({
            step: "form",
            editingIndex: index,
            form: {
                titulo: attr.titulo,
                alias: attr.alias,
                tipo: attr.tipo,
                opcoes: [...(attr.opcoes || [])],
                novaOpcao: "",
            },
        });
    }

    goToList() {
        this.setState({ step: "list", editingIndex: null, form: { ...emptyForm } });
    }

    updateFormField(field, value) {
        this.setState((prev) => ({
            form: { ...prev.form, [field]: value },
        }));
    }

    onTituloChange(value) {
        this.setState((prev) => ({
            form: {
                ...prev.form,
                titulo: value,
                alias: prev.form.alias === toAlias(prev.form.titulo) || prev.form.alias === ""
                    ? toAlias(value)
                    : prev.form.alias,
            },
        }));
    }

    addOpcao() {
        const { form } = this.state;
        const novaOpcao = (form.novaOpcao || "").trim();
        if (!novaOpcao || form.opcoes.includes(novaOpcao)) return;
        this.setState((prev) => ({
            form: {
                ...prev.form,
                opcoes: [...prev.form.opcoes, novaOpcao],
                novaOpcao: "",
            },
        }));
    }

    removeOpcao(index) {
        this.setState((prev) => {
            const opcoes = [...prev.form.opcoes];
            opcoes.splice(index, 1);
            return { form: { ...prev.form, opcoes } };
        });
    }

    confirmForm() {
        const { form, attributes, editingIndex } = this.state;
        const newAttr = {
            titulo: form.titulo.trim(),
            alias: form.alias.trim() || toAlias(form.titulo),
            tipo: form.tipo || 'TEXT',
            opcoes: form.tipo === "OPTIONS" ? [...form.opcoes] : [],
        };

        const updated = [...attributes];
        if (editingIndex !== null) {
            updated[editingIndex] = newAttr;
        } else {
            updated.push(newAttr);
        }

        this.setState({ attributes: updated, step: "list", editingIndex: null, form: { ...emptyForm } });
    }

    moveAttribute(index, direction) {
        const { attributes } = this.state;
        const updated = [...attributes];
        const swapWith = direction === 'up' ? index - 1 : index + 1;
        [updated[index], updated[swapWith]] = [updated[swapWith], updated[index]];
        this.setState({ attributes: updated });
    }

    moveOpcao(index, direction) {
        this.setState((prev) => {
            const opcoes = [...prev.form.opcoes];
            const swapWith = direction === 'up' ? index - 1 : index + 1;
            [opcoes[index], opcoes[swapWith]] = [opcoes[swapWith], opcoes[index]];
            return { form: { ...prev.form, opcoes } };
        });
    }

    removeAttribute(index) {
        const { attributes } = this.state;
        const updated = [...attributes];
        updated.splice(index, 1);
        this.setState({ attributes: updated });
    }

    isFormValid() {
        const { form } = this.state;
        if (!form.titulo.trim()) return false;
        if (form.tipo === "OPTIONS" && form.opcoes.length === 0) return false;
        return true;
    }

    async save() {
        const { attributes } = this.state;
        this.setState({ saveLoading: true });

        const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();

        const foodResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId,
            "customer_attributes",
            { customer_attributes: attributes }
        );

        if (foodResponse.getErrors([]).length > 0) {
            alert({ text: foodResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({ saveLoading: false });
            return;
        }

        await OlgaEnvironmentsAPI.putConfigurationByAlias("customer_attributes", attributes);

        alert({ text: "Configuração alterada com sucesso", buttonText: "Ok" });
        this.setState({ saveLoading: false });
        this.props.onSave();
    }

    renderList() {
        const { attributes, saveLoading } = this.state;
        const { onClose } = this.props;

        return (
            <Drawer visible onClose={onClose} closeInFade title="Campos personalizados">
                <div className={styles.secretDrawerContainer}>
                    <div className={styles.container}>

                        <Label>Campos ({attributes.length})</Label>

                        {attributes.length > 0 && (
                            <div>
                                {attributes.map((attr, index) => (
                                    <div key={attr.alias + index} style={{ marginBottom: 12 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "10px 12px",
                                                background: "var(--box-up)",
                                                borderRadius: 8,
                                            }}
                                        >
                                            <div>
                                                <p style={{ fontWeight: 600, fontSize: 14, marginBottom: 2, color: "#808080" }}>
                                                    {attr.titulo}
                                                </p>
                                                <p style={{ fontSize: 12, color: "#808080" }}>
                                                    {TIPOS_LABEL[attr.tipo]}
                                                    {attr.alias ? ` · ${attr.alias}` : ""}
                                                </p>
                                            </div>
                                            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                                                {index !== 0 && (
                                                    <span style={{ cursor: "pointer" }} onClick={() => this.moveAttribute(index, 'up')}>
                                                        <Icon name="chevron-up" size="sm" />
                                                    </span>
                                                )}
                                                {index !== attributes.length - 1 && (
                                                    <span style={{ cursor: "pointer" }} onClick={() => this.moveAttribute(index, 'down')}>
                                                        <Icon name="chevron-down" size="sm" />
                                                    </span>
                                                )}
                                                <span
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.openEditForm(index)}
                                                >
                                                    <Icon name="pen" size="sm" />
                                                </span>
                                                <span
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.removeAttribute(index)}
                                                >
                                                    <Icon name="trash" size="sm" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        <Button className="w-100 mt-15" onClick={() => this.openAddForm()}>
                            Adicionar campo
                        </Button>
                    </div>

                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.save()}
                            loading={saveLoading}
                            disabled={saveLoading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }

    renderForm() {
        const { form, editingIndex } = this.state;
        const { onClose } = this.props;
        const isEditing = editingIndex !== null;

        return (
            <Drawer
                visible
                onClose={onClose}
                closeInFade
                showBackButton
                backButton={() => this.goToList()}
                title={isEditing ? "Editar campo" : "Novo campo"}
            >
                <div className={styles.secretDrawerContainer}>
                    <div className={styles.container}>

                        <Input
                            label="Título"
                            placeholder="Ex: Profissão"
                            design="two"
                            value={form.titulo}
                            onChange={(e) => this.onTituloChange(e.target.value)}
                        />

                        <Input
                            label="Alias"
                            placeholder="Ex: profissao"
                            design="two"
                            className="mt-15"
                            value={form.alias}
                            onChange={(e) => this.updateFormField("alias", e.target.value)}
                        />

                        <Select
                            label="Tipo"
                            className="mt-15"
                            design="two"
                            value={form.tipo}
                            onChange={(e) => this.updateFormField("tipo", e.target.value)}
                            options={TIPOS.map((t) => ({ label: t.title, value: t.option }))}
                        >
                            {TIPOS.map((t) => (
                                <option key={t.option} value={t.option}>
                                    {t.title}
                                </option>
                            ))}
                        </Select>

                        {form.tipo === "OPTIONS" && (
                            <div className="mt-20">
                                <Hairline className="mb-15" />
                                <Label>Opções disponíveis ({form.opcoes.length})</Label>

                                <div style={{ display: "flex", gap: 8 }}>
                                    <Input
                                        placeholder="Nova opção"
                                        design="two"
                                        className="w-100"
                                        value={form.novaOpcao}
                                        onChange={(e) => this.updateFormField("novaOpcao", e.target.value)}
                                        onKeyDown={(e) => e.key === "Enter" && this.addOpcao()}
                                        style={{ flex: 1 }}
                                    />
                                    <Button
                                        onClick={() => this.addOpcao()}
                                        disabled={!form.novaOpcao.trim()}
                                    >
                                        <Icon name="plus" size="sm" />
                                    </Button>
                                </div>

                                {form.opcoes.length > 0 && (
                                    <div className="mt-15">
                                        {form.opcoes.map((opcao, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    padding: "8px 12px",
                                                    background: "var(--box-up)",
                                                    borderRadius: 8,
                                                    marginBottom: 8,
                                                    color: "#808080"
                                                }}
                                            >
                                                <p style={{ fontSize: 12 }}>{opcao}</p>
                                                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                                                    {i !== 0 && (
                                                        <span style={{ cursor: "pointer" }} onClick={() => this.moveOpcao(i, 'up')}>
                                                            <Icon name="chevron-up" size="sm" />
                                                        </span>
                                                    )}
                                                    {i !== form.opcoes.length - 1 && (
                                                        <span style={{ cursor: "pointer" }} onClick={() => this.moveOpcao(i, 'down')}>
                                                            <Icon name="chevron-down" size="sm" />
                                                        </span>
                                                    )}
                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => this.removeOpcao(i)}
                                                    >
                                                        <Icon name="times" size="sm" />
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.confirmForm()}
                            disabled={!this.isFormValid()}
                        >
                            Confirmar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }

    render() {
        const { pageLoading, step } = this.state;
        const { onClose } = this.props;

        if (pageLoading) {
            return (
                <Drawer visible onClose={onClose} closeInFade title="Campos personalizados">
                    <div className="d-flex w-100 h-100 align-center justify-center">
                        <Loading />
                    </div>
                </Drawer>
            );
        }

        if (step === "form") return this.renderForm();
        return this.renderList();
    }
}
